import { IAsyncState } from 'apps/dialect/src/app/core/interfaces/async-state.interface';
import { IDialectResponse } from 'apps/dialect/src/app/core/interfaces/dialect-response.interface';
import { BehaviorSubject } from 'rxjs';

import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Router } from '@angular/router';
import { CommonsModule } from '@peca/commons';
import { DesignSystemModule } from '@peca/design-system';

@Component({
  selector: 'peca-search-dialect-details',
  templateUrl: './search-dialect-details.component.html',
  styleUrl: './search-dialect-details.component.scss',
  imports: [CommonModule, CommonsModule, DesignSystemModule, MatFormFieldModule],
})
export class SearchDialectDetailsComponent {
  @Input()
  dialect$!: BehaviorSubject<IAsyncState<IDialectResponse>>;

  router = inject(Router);

  onClickDialectDetails(dialect: IDialectResponse | null | undefined) {
    if (!dialect) return;
    this.router.navigate(['.', 'query', dialect.id]);
  }
}
